import React, { useContext, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import PassportTableInit from './tables/PassportTableInit'
import { LoginContext } from '../../reactcontext/ReactContext';

const Landing = () => {
  const location = useLocation();
  const { loginInfo } = useContext(LoginContext);
  const navigate=useNavigate()
  useEffect(() => {
    if (!loginInfo.login) {
      navigate("/passport_exp");
    }
  }, [loginInfo]);
  let pathKey = location.pathname.split("/").pop();
  
  let displayText = "Already Expired";
  if(pathKey==="1_month"){
    displayText = "1 month from today";
  } else if(pathKey==="3_month"){
    displayText = "3 months from today";
  } else if(pathKey==="6_month"){
    displayText = "6 months from today";
  } else if(pathKey==="pass_expired" || pathKey==="passport_exp"){
    displayText = "Already Expired";
  }

  if(pathKey==="passport_exp"){
    pathKey="pass_expired"
  }

  return (
    <div className='w-full flex h-full flex-col items-center justify-between relative gap-3'>
      <div className='self-start'>
        <Link
        to={'/dashboard'}
        className='text-yellow-700'>
          Dashboard
        </Link> 
        {' > '} 
        Passport Expire
      </div>

      {/* Render active tab content */}
      <div className='w-full p-2 flex items-center flex-col justify-center h-full gap-3'>
        <h1 className='text-xl font-semibold'>Passports {displayText}</h1>

        <PassportTableInit filterType={pathKey} />
      </div>

    </div>
  )
}

export default Landing
